/**
 * The main api service
 */
import http from '@util/http';
import { core, crm } from '../req';

/**
 * 获取客户总表
 */
export async function queryCustomList(params) {
  return http.get(crm.GET_CUSTOM_LIST, params);
}

/**
 * 保存客户
 * @param {} params
 * @returns {}
 */
export async function querySaveCustom(params) {
  return http.post(crm.CUSTOM_SAVE, params);
}

export async function querySaveDepartmentCustom(params) {
  return http.post(crm.CUSTOM_DEPARTMENT_SAVE, params);
}

/**
 * 一级行业分类
 * @returns {}
 */
export async function queryCustomCategory(category) {
  return http.get(core.GET_CUISTOM_CATEGORY, {
    category: category || '',
  });
}

/**
 * 获取客户详情
 * @param {} uuid
 * @returns {}
 */
export async function queryCustomInfo(uuid) {
  return http.get(crm.GET_CUSTOM_INFO, { uuid });
}

/**
 * 线索模板下载
 */
export async function queryDownloadClueTemplate() {
  http.download(crm.DOWNLOAD_CLUE_TEMPLATE, {}, '线索模板.xlsx');
}

/**
 * 客户的分属部门分配情况
 * @param {} uuid
 * @returns {}
 */
export async function queryCustomDepartmentDistributionList(uuid) {
  return http.get(crm.GET_CUSTOM_DEPARTMENT_DISTRIBUTION_LIST, {
    uuid,
  });
}

/**
 * 保存客户的分属部门关联
 * @param {} params
 * @returns {}
 */
export async function querySaveCustomDepartmentDistribution(params) {
  return http.post(crm.CUSTOM_DEPARTMENT_DISTRIBUTION_SAVE, params);
}

/**
 * 分属部门的客户列表
 * @param {} params
 * @returns {}
 */
export async function queryCustomDepartmentList(params) {
  return http.get(crm.GET_CUSTOM_DEPARTMENT_LIST, params);
}

/**
 * 分属部门的客户详情
 * @param {} params
 * @returns {}
 */
export async function queryCustomDepartmentInfo(uuid) {
  return http.get(crm.GET_CUSTOM_DEPARTMENT_INFO, { uuid });
}

/**
 * 全部客户保护列表
 * @param {} params
 * @returns {}
 */
export async function queryCustomProtectionList(params) {
  return http.get(crm.GET_CUSTOM_PROTECTION_LIST, params);
}

/**
 * 个人客户保护列表
 * @param {} params
 * @returns {}
 */
export async function queryMyCustomProtectionList(params) {
  return http.get(crm.GET_CUSTOM_PROTECTION_MY_LIST, params);
}

/**
 * 客户保护
 * @param {} params
 * @returns {}
 */
export async function querySaveCustomProtection(params) {
  return http.post(crm.CUSTOM_PROTECTION_SAVE, params);
}

/**
 * 客户保护分配
 * @param {} params
 * @returns {}
 */
export async function querySaveCustomProtectionDistribution(params) {
  return http.post(crm.CUSTOM_DEPARTMENT_DISTRIBUTION_SAVE, params);
}

/**
 * 取消客户保护
 * @param {} uuid
 * @returns {}
 */
export async function queryCancelCustomProtection(params) {
  return http.get(crm.CUSTOM_PROTECTION_CANCEL, params);
}

export async function queryClueList(params) {
  return http.get(crm.GET_CLUE_LIST, params);
}

export async function querySaveClue(params) {
  return http.post(crm.CLUE_SAVE, params);
}

export async function queryImportClue(params) {
  return http.post(crm.CLUE_IMPORT, params);
}

export async function queryClueInfo(params) {
  return http.get(crm.GET_CLUE_INFO, params);
}

export async function queryDepartmentList(params) {
  return http.get(crm.GET_DEPARTMENT_LIST, params);
}

export async function queryDepartmentMy(params) {
  return http.get(crm.GET_DEPARTMENT_MY, params);
}

export async function querySaveDepartment(params) {
  return http.post(crm.GET_DEPARTMENT_SAVE, params);
}

export async function querySaveDepartmentOpportunity(params) {
  return http.post(crm.DEPARTMENT_OPPORTUNITY_SAVE, params);
}

export async function queryDepartmentOpportunity(params) {
  return http.get(crm.DEPARTMENT_OPPORTUNITY_INFO, params);
}

export async function querySaveDepartmentProduct(params) {
  return http.post(crm.DEPARTMENT_PRODUCT_SAVE, params);
}

export async function queryDepartmentProduct(params) {
  return http.get(crm.DEPARTMENT_PRODUCT_INFO, params);
}

export async function queryCustomField(params) {
  return http.get(core.GET_CUISTOM_FIELD, params);
}

export async function queryCustomView(params) {
  return http.get(crm.GET_CUISTOM_VIEW, params);
}

export async function querySaveCustomView(params) {
  return http.post(crm.CUISTOM_VIEW_SAVE, params);
}

export async function querySaveDepartmentProtection(params) {
  return http.post(crm.DEPARTMENT_PROTECTION_SAVE, params);
}

export async function queryDepartmentProtection(params) {
  return http.get(crm.DEPARTMENT_PROTECTION_INFO, params);
}

export async function queryCustomContact(params) {
  return http.get(crm.GET_CUSTOM_CONTACT_LIST, params);
}

export async function querySaveCustomContact(params) {
  return http.post(crm.CUSTOM_CONTACT_SAVE, params);
}

export async function queryVerifyCustomContact(params) {
  return http.post(crm.CUSTOM_CONTACT_VERIFY, params);
}

export async function querySaveBusiness(params) {
  return http.post(crm.OPPORTUNITY_SAVE, params);
}

export async function queryBusinessList(params) {
  return http.get(crm.GET_OPPORTUNITY_LIST, params);
}

export async function queryBusinessInfo(params) {
  return http.get(crm.GET_OPPORTUNITY_INFO, params);
}



// WEBPACK FOOTER //
// ./src/api/crm/crm.js